(function () {
  'use strict';

  var isInternal = function (url) {
    return url.origin === window.location.origin && !/^(mailto:|tel:|javascript:|#)/i.test(url.href);
  };

  var decorate = function () {
    document.querySelectorAll('a[href]').forEach(function (anchor) {
      if (anchor.classList.contains('toc-b2b-return')) return;
      var raw = anchor.getAttribute('href');
      if (!raw || raw.charAt(0) === '#' || /^(mailto:|tel:|javascript:)/i.test(raw)) return;
      var target;
      try { target = new URL(raw, window.location.origin); } catch (error) { return; }
      if (!isInternal(target)) return;
      if (target.pathname === '/') target.pathname = '/pages/retail';
      if (target.pathname.indexOf('/pages/b2b-') === 0) return;
      if (target.pathname === '/pages/retail') {
        target.searchParams.set('view', 'retail');
      } else if (target.pathname !== '/checkout') {
        target.searchParams.set('view', 'toc');
      }
      anchor.href = target.pathname + target.search + target.hash;
    });
  };

  var startProductRails = function () {
    if (window.__tocProductRailsStarted || !window.theme || !window.theme.homepage_section || !window.jQuery) return;
    if (!document.querySelector('[data-section-type="product-list"]:not(.ajax-loaded)')) return;
    window.__tocProductRailsStarted = true;
    window.theme.homepage_section.init();
    window.jQuery(window).triggerHandler('load');
  };

  document.addEventListener('DOMContentLoaded', decorate);
  document.addEventListener('DOMContentLoaded', function () { window.setTimeout(startProductRails, 0); });
  document.addEventListener('shopify:section:load', decorate);
  // Collection sorting/filtering replaces the product grid through AJAX. Re-apply
  // the ToC route context to links added after the initial page render.
  var decorateQueued = false;
  var queueDecorate = function () {
    if (decorateQueued) return;
    decorateQueued = true;
    window.setTimeout(function () {
      decorateQueued = false;
      decorate();
    }, 0);
  };
  if (window.MutationObserver && document.body) {
    new MutationObserver(function (mutations) {
      if (mutations.some(function (mutation) { return mutation.addedNodes && mutation.addedNodes.length; })) {
        queueDecorate();
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState !== 'loading') window.setTimeout(startProductRails, 0);
})();
